import { db } from '../firebase/config';
import { collection, doc, setDoc, deleteDoc, getDocs, query, where } from 'firebase/firestore';

// Aggiunge un prodotto alla wishlist dell'utente
export const addToWishlist = async (userId, product) => {
  try {
    const wishlistRef = doc(db, 'users', userId, 'wishlist', product.id);
    await setDoc(wishlistRef, {
      ...product,
      addedAt: new Date().toISOString()
    });
    return true;
  } catch (error) {
    console.error('Errore nell\'aggiunta alla wishlist:', error);
    throw error;
  }
};

// Rimuove un prodotto dalla wishlist dell'utente
export const removeFromWishlist = async (userId, productId) => {
  try {
    const wishlistRef = doc(db, 'users', userId, 'wishlist', productId);
    await deleteDoc(wishlistRef);
    return true;
  } catch (error) {
    console.error('Errore nella rimozione dalla wishlist:', error);
    throw error;
  }
};

// Ottiene tutti i prodotti nella wishlist dell'utente
export const getWishlist = async (userId) => {
  try {
    const wishlistRef = collection(db, 'users', userId, 'wishlist');
    const snapshot = await getDocs(wishlistRef);
    return snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
  } catch (error) {
    console.error('Errore nel recupero della wishlist:', error);
    throw error;
  }
};

// Verifica se un prodotto è nella wishlist dell'utente
export const isInWishlist = async (userId, productId) => {
  try {
    const wishlistRef = collection(db, 'users', userId, 'wishlist');
    const q = query(wishlistRef, where('id', '==', productId));
    const snapshot = await getDocs(q);
    return !snapshot.empty;
  } catch (error) {
    console.error('Errore nella verifica della wishlist:', error);
    throw error;
  }
}; 